<template>
  <PrivacySection title="11. Trattamento di Dati di Minori">
    <p>
      I nostri Servizi non sono destinati a minori di 18 anni. Non raccogliamo 
      consapevolmente dati personali di minori. Se un genitore o tutore si accorge 
      che il proprio minore ci ha fornito dati personali senza il suo consenso, 
      ci contatti immediatamente e provvederemo alla rimozione di tali informazioni.
    </p>
  </PrivacySection>
</template>

<script>
import PrivacySection from '../PrivacySection.vue'

export default {
  name: 'MinorsSection',
  components: {
    PrivacySection
  }
}
</script>

